import { useSelector } from 'react-redux';

export default function useLoggedInUser() {
  // @ts-expect-error [MC-2850] - TS2339 - Property 'user' does not exist on type 'DefaultRootState'.
  const userImmutable = useSelector((state) => state.user);
  const user = userImmutable.getIn(['data', '_embedded', 'user']);
  const adminHref = userImmutable.getIn(['data', '_links', 'admin', 'href']);
  const userAvatarUrl = user?.getIn(['_links', 'picture', 'href']);
  return {
    isLoggedIn: !!user,
    isAdmin: !!adminHref,
    userAvatarUrl,
    user: user?.toJS(),
  };
}
